export const formatNumber = (number, currency = "SEK", market = "sv-SE") => {
    if (currency === "€") currency = "EUR";
    if (currency === "£") currency = "GBP"
    return new Intl.NumberFormat(market, { style: 'currency', currency: currency }).format(number);
}